import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { isBankCardExpired } from "../../utils/siteUtils";
import { bankCardSubTypes } from "../../utils/lynkco-constants";
import { Icon } from "../../elements";
import "./style.scss";

/**
 * @param card {BankCard}
 * @param expiredText {string}
 * @return {JSX.Element}
 * @constructor
 */
const AccountBankCardInformation = ({ card, showIcon, expiredText, children }) => {
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    if (card?.expirationMonth) {
      const _isExpired = isBankCardExpired(card.expirationYear, card.expirationMonth);
      setIsExpired(_isExpired);
    }
  }, [card]);
  const rootClasses = classNames("account-bank-card-information", {
    "active-card": showIcon
  });
  const cardNameClasses = classNames("card-name-wrapper", isExpired ? "expired" : "");
  return (
    <div className={rootClasses}>
      <div className="account-bank-card-information__content grid">
        <div className="icon-wrapper">{card?.cardSubType === bankCardSubTypes.actived && <Icon name="Check" />}</div>
        <div className={cardNameClasses}>
          <p className="card-name">{card?.cardMethodName}</p>
          <p>**** **** **** {card?.cardNo}</p>
          {isExpired && <p className="expired-text">{expiredText?.value || "Expired"}</p>}
        </div>
        <div className="bank-card-extra">
          <p>{card?.cardHolder}</p>
          <p>{card?.formattedExpireDate}</p>
        </div>
        <div className="bank-card-actions">{children}</div>
      </div>
    </div>
  );
};
export default AccountBankCardInformation;
